import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, of, Observable } from 'rxjs';
import { ChatUser } from '../models/user';
import { prodAPI } from '../../../env';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  private apiUrl = `${prodAPI}/api/overlay/chat-bubbles`;
  private usersSignal = signal<ChatUser[]>([]);

  constructor(private http: HttpClient) {
    // если хочешь — можно убрать автозагрузку
    this.loadChatUsers(); 
  }

  /** Реактивный доступ к пользователям (readonly signal) */
  getChatUsers() {
    return this.usersSignal.asReadonly();
  }

  /** Генерация тестовых пользователей */
  generateTestUsers(count: number = 20): ChatUser[] {
    const users: ChatUser[] = [];
    for (let i = 1; i <= count; i++) {
      users.push({
        id: `test-${i}`,
        username: `TestUser${i}`,
        avatar: `favicon.png`,
        is_discord_vip: i % 2 === 0,
        is_youtube_member: i % 3 === 0,
        youtube_membership_level: i % 4 === 0 ? 'Lion King' : 'Cub'
      });
    }
    return users;
  }

  /** Получить пользователей напрямую (Observable) */
  fetchChatUsers(): Observable<ChatUser[]> {
    return this.http.get<ChatUser[]>(this.apiUrl).pipe(
      catchError(err => {
        console.error('API request failed:', err);
        return of([]); // отдаём пустой массив, чтобы не падало
      })
    );
  }

  /** Записать пользователей в сигнал (используем внутри сервиса) */
  loadChatUsers(): void {
    this.fetchChatUsers().subscribe({
      next: (users) => this.usersSignal.set(users || []),
      error: (err) => {
        console.error('Failed to load users:', err);
        this.usersSignal.set([]);
      }
    });
  }
}
